import { over } from "lodash";
import { z, ZodType } from "zod";
import { dateString, nullableNumber, numericString, optional, ZodEntriesOf } from "../../../../utils";

export const PrinterSchema = z.object({
    id: optional(z.number()),
    name: z.string().min(1, "Name is required"),
    unit: z.string().min(1, "Unit is required"),
    ipAddress: z
        .string()
        .min(1, "IP address is required")
        .regex(
            /^(25[0-5]|2[0-4][0-9]|1?[0-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1?[0-9]?[0-9])){3}$/,
            "Must be a valid IPv4 address"
        ),
    createdAt: dateString,
    createdBy: z.string().email("Created By must be a valid email"),
    modifiedAt: dateString,
    modifiedBy: z.string().email("Modified By must be a valid email"),
});

export const PrinterSchemaUpdate = PrinterSchema.extend({
    id: z.number().min(1, "ID is required")
});

